import _ from "lodash";
import { createSelector } from "reselect";
import { ORDER_TYPES } from "../../../../components/OrderTypeSelector/orderTypeSelectorConstants";
import {
    getLiteTradeAccountOrders,
    getLiteTradeAccountPositions,
    makeSelectorGetLiteTradeAccountOrderProtectionOrderInfoByType,
    makeSelectorGetLiteTradeAccountPositionProtectionOrderInfoByType
} from "../../../../modules/LiteTrade/liteTradeSelectors";

export const makeSelectorMobilePositionUpdateProtectionOrderInfo = ({ orderId, positionCode, protectionOrderType }) => createSelector(
    [
        makeSelectorGetLiteTradeAccountOrderProtectionOrderInfoByType(orderId, protectionOrderType),
        makeSelectorGetLiteTradeAccountPositionProtectionOrderInfoByType(positionCode, protectionOrderType),
    ], (orderInfoByOrderId, orderInfoByPositionCode) => orderInfoByOrderId || orderInfoByPositionCode,
);

export const makeSelectorMobilePositionUpdateInitialData = ({orderId, positionCode}) => createSelector(
    [getLiteTradeAccountOrders, getLiteTradeAccountPositions], (orders, positions) => {
        const orderInfo = _.find(orders, {orderId: parseInt(orderId)});
        const positionInfo = _.find(positions, {positionCode});
        if (orderInfo) {
            return {
                orderCode: orderInfo.orderCode,
                quantity: orderInfo.legs[0].quantity,
                price: orderInfo.legs[0].price,
                side: orderInfo.side,
                symbol: orderInfo.instrument,
                type: orderInfo.type,
            }
        } else if (positionInfo) {
            return {
                quantity: positionInfo.quantity,
                positionCode: positionInfo.positionCode,
                price: positionInfo.openPrice,
                side: positionInfo.side,
                symbol: positionInfo.symbol,
                type: ORDER_TYPES.MARKET,
            }
        }
        return {};
    }
)
